import React from 'react';

import SharedMonomerCreationMethodPicker from './SharedMonomerCreationMethodPicker';

export default function MonomerCreationMethodPicker(): JSX.Element {
  return (
    <SharedMonomerCreationMethodPicker
      helmLibraryUrl="/monomers/create/helm-library"
      csvUploadUrl="/monomers/create/bulk-csv"
      manualCreateUrl="/monomers/create/manual"
      libraryName="Monomer library"
      libraryUrl="/monomers"
    />
  );
}
